import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { OfferCountdown } from './OfferCountdown';
import { trackAdClick } from '../../utils/siteTracking';

export const SpecialCard = ({ special, image = special.image, variant = 0, index = 0, placement = 'specials_page' }) => {
  const tid = variant ? `${special.id}-${variant}` : special.id;
  return (
    <Link
      to={`/specials/${special.slug}`}
      onClick={() => trackAdClick(special.slug, image, placement)}
      className="group flex flex-col rounded-3xl overflow-hidden bg-white shadow-sm hover:shadow-2xl hover:-translate-y-1 transition-[box-shadow,transform] duration-300 animate-fade-up"
      style={{ animationDelay: `${index * 90}ms` }}
      data-testid={`special-${tid}`}
    >
      <div className="aspect-square overflow-hidden bg-stone-200">
        <img src={image} alt={`${special.title} - ComfortMaster Heating & Air special offer`}
          className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700" loading="lazy" data-testid={`special-image-${tid}`} />
      </div>
      <div className="flex flex-col flex-1 gap-2.5 sm:gap-3 px-5 sm:px-6 py-4 sm:py-5">
        <OfferCountdown validUntil={special.validUntil} className="self-start" testId={`special-countdown-${tid}`} />
        <h3 className="font-heading font-bold text-slate-900 text-xl leading-tight">{special.title}</h3>
        <p className="text-slate-600 text-sm line-clamp-2">{special.description}</p>
        <span className="mt-auto pt-1 inline-flex items-center gap-2 min-h-[44px] sm:min-h-0 text-emerald-600 font-bold text-sm group-hover:gap-3 transition-[gap]" data-testid={`special-details-link-${tid}`}>
          See Details & Book <ArrowRight size={16} />
        </span>
      </div>
    </Link>
  );
};
